<div class="other-settings-container">
  <div>
    <form [formGroup]="companyDomainForm">
      <div class="setting-row">
        <span class="setting-label">Company Domain <sup>*</sup></span>
        <input type="text" class="form-control" formControlName="companyDomain" />
      </div>
    </form>
  </div>

  <div>
    <h5 class="mb-3">Login Mechanism</h5>

    <form [formGroup]="loginMechanismForm">
      <div class="setting-row">
        <span class="setting-label">Password Login</span>
        <div class="custm-toglbtn">
          <input type="checkbox" id="passwordLogin" formControlName="passwordLogin" />
          <label for="passwordLogin"></label>
        </div>
      </div>

      <div class="setting-row">
        <span class="setting-label">OTP Login</span>
        <div class="custm-toglbtn">
          <input type="checkbox" id="otpLogin" formControlName="otpLogin" />
          <label for="otpLogin"></label>
        </div>
      </div>

      <div class="setting-row">
        <span class="setting-label">SSO Login</span>
        <div class="custm-toglbtn">
          <input type="checkbox" id="ssoLogin" formControlName="ssoLogin" />
          <label for="ssoLogin"></label>
        </div>
      </div>
    </form>
  </div>

  <div class="mt-4" *ngIf="loginMechanismForm.get('ssoLogin')?.value">
    <h5 class="mb-3">SSO Setup</h5>

    <form [formGroup]="ssoForm">
      <div class="setting-row">
        <span class="setting-label">Tenant ID <sup>*</sup></span>
        <input type="text" class="form-control" formControlName="tenantId" />
      </div>

      <div class="setting-row">
        <span class="setting-label">Client ID <sup>*</sup></span>
        <input type="text" class="form-control" formControlName="clientId" />
      </div>
    </form>
  </div>

  <div class="mt-4">
    <h5 class="mb-3">Mail Intimation Settings</h5>

    <form [formGroup]="mailSettingsForm">
      <div class="setting-row">
        <span class="setting-label">Trigger Welcome Email to Employees</span>
        <div class="custm-toglbtn">
          <input type="checkbox" id="triggerEmployeeWelcomeEmail" formControlName="triggerEmployeeWelcomeEmail" />
          <label for="triggerEmployeeWelcomeEmail"></label>
        </div>
      </div>

      <div class="setting-row">
        <span class="setting-label">Trigger Welcome Email to EE Admins</span>
        <div class="custm-toglbtn">
          <input type="checkbox" id="triggerAdminWelcomeEmail" formControlName="triggerAdminWelcomeEmail" />
          <label for="triggerAdminWelcomeEmail"></label>
        </div>
      </div>

      <div class="setting-row">
        <span class="setting-label">Enable Notifications to Employees &amp; EE Admins</span>
        <div class="custm-toglbtn">
          <input
            type="checkbox"
            id="employeeAndEeAdminNotificationsEnabled"
            formControlName="employeeAndEeAdminNotificationsEnabled"
            disabled
          />
          <label for="employeeAndEeAdminNotificationsEnabled"></label>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="d-flex justify-content-end mt-4">
  <button class="btn btn-outline-secondary me-2" (click)="discard()">Discard</button>
  <button class="btn btn-success" (click)="finish()">Finish Onboarding</button>
</div>
